import axiosService from '../plugins/axiosService'

export default {
    async fonctAll(){
        return axiosService.get('/api/fonctionnality/all')
    }
}
